import { HttpErrorService } from '@/services/HttpError.service'
import { orderKitErrorHandbook } from '@/models/Errors'
import { HttpService } from '@/services/Http.service'
import type { JsonScheme, PngScheme, SvgScheme } from '~/models'

export class OrderKitService {
  private httpErrorService: HttpErrorService<keyof typeof orderKitErrorHandbook>
  private endpoint = '/order-kit'
  private httpService: HttpService

  constructor(httpService: HttpService) {
    this.httpService = httpService
    this.httpErrorService = new HttpErrorService(
      orderKitErrorHandbook,
      'order-kit',
    )
  }

  async fetchSectorScheme(eventId: number, sectorId: number) {
    const url = `/orders/sectors/scheme/${eventId}/${sectorId}`

    return await this.httpService
      .post<string>(url, {
        requestConfig: {
          cancellable: true,
          needCancelAtChangeRoute: true,
          forceRequest: true,
        },
        fetchConfig: {
          body: {},
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }

  async getScheme(eventId: number) {
    const url = [this.endpoint, eventId, 'scheme'].join('/')

    return await this.httpService
      .post<SvgScheme | JsonScheme | PngScheme>(url, {
        requestConfig: {
          cancellable: true,
          needCancelAtChangeRoute: true,
          forceRequest: true,
        },
        fetchConfig: {
          body: {},
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }
}
